<ng-container>
  <div [ngClass]="{'popover-arrow': !!content}" data-popper-arrow ></div>
  <ng-container #popoverTemplate></ng-container>
</ng-container>
